import {
	trackPageViews,
	trackClicks,
	refreshTrackClicks,
	trackErrors,
	trackStructEvent,
	removeFromGlobalContexts,
} from '@rtl_nl/rtl-snowplow';
import { analyticsByRoute } from '../../helpers/registration';
import { addToGlobalContexts as addToGlobalContextsSnowplow } from '@rtl_nl/rtl-snowplow';

const APP_ID = 'onboarding.videoland.com';

const mapEnv = { production: 'prod', development: 'dev', test: 'test', acceptance: 'acc' };

/*
 * Function to extract the Snowplow Domain User Information from the first-party cookie set by the Snowplow JavaScript Tracker
 *
 * @param string cookieName (optional) The value used for "cookieName" in the tracker constructor argmap
 * (leave blank if you did not set a custom cookie name)
 *
 * @return string or bool The ID string if the cookie exists or false if the cookie has not been set yet
 */
export const getSnowplowDuid = (cookieNameParam) => {
	const cookieName = cookieNameParam || '_sp_';
	const matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
	const match = document.cookie.match(matcher);
	if (!match) return false;
	const split = match[1].split('.');
	if (match && match[1]) {
		return {
			domain_userid: split[0],
			domain_sessionidx: split[2],
			domain_sessionid: split[5],
		};
	} else {
		return false;
	}
};

const getDataByRoute = ({ location } = {}) => {
	const allAnalyticsByRoute = { ...analyticsByRoute };
	const newLocation = location ?? window.location.pathname;

	return allAnalyticsByRoute[newLocation.replace(/\/+$/, '')];
};

const getContextData = ({ pageNamePlatform } = {}) => {
	const data = {
		appId: APP_ID,
		enableExperimentalData: true,
	};

	const pageName = pageNamePlatform ?? getDataByRoute({ pageNamePlatform });

	if (pageName) {
		data.pageName = pageName;
	}

	return data;
};

export const getPlatformData = ({ pageNamePlatform, location } = {}) => {
	const pageName = pageNamePlatform ?? getDataByRoute({ pageNamePlatform, location });

	if (!pageName) {
		return null;
	}

	return {
		pageName: typeof pageName === 'string' ? pageName : pageName.pageName,
		platformName: 'videolandweb',
		language: 'nl-NL',
		environment: mapEnv[__ENVIRONMENT__],
		brandName: 'videoland',
	};
};

export const initiatePageViewTracking = async ({ pageNamePlatform, rtlPurchase, rtlUser } = {}) => {
	const data = getContextData({ pageNamePlatform });

	if (data.appId && data.pageName) {
		await trackPageViews({ pageName: data.pageName, ...data, rtlPurchase, rtlUser });
	}
};

export const initateLinkClickTracking = async () => {
	await trackClicks({
		appId: APP_ID,
		brandName: document.title ? document.title : APP_ID,
	});
};

export const refreshLinkClickTracking = async () => {
	await refreshTrackClicks(APP_ID);
};

export const initiateErrorTracking = async (error) => {
	if (__CLIENT__) {
		if (error) {
			await trackErrors({ appId: APP_ID, customError: error });
		} else {
			await trackErrors({ appId: APP_ID });
		}
	}
};

export const initiateTrackStructEvent = async (data) => {
	const commonData = getContextData();
	await trackStructEvent({ ...data, ...commonData });
};

export const addToGlobalContexts = async (data) => {
	await addToGlobalContextsSnowplow({ ...data, appId: APP_ID });
};

export const removeFromGlobalContext = async (data) => {
	await removeFromGlobalContexts({ ...data, appId: APP_ID });
};
